import { Box } from "@mui/material";
import { ReactElement } from "react";
import OfflineCard from "../App/OfflineCard";
import { useOffline } from "../utils";
import { useApiFind } from "@cdv/jazz-ui";
import { FindAudiosDocument } from "../../api";
import Player from "./Player";
import AppBar from "../ui/AppBar";

export default function Content(): ReactElement {
  const offline = useOffline();

  if (offline) {
    return (
      <>
        <AppBar title={"Audio"} />

        <OfflineCard />
      </>
    );
  }
  return (
    <Box>
      <Player />
    </Box>
  );
}
